import {listener, removeClass, removeElement} from "../../../../../modules/vegas/js/util";
import VGCatalogCart from "./cart";

const cart = new VGCatalogCart();

// удаляем со страницы товара
listener('click', '[data-product] [data-cart][data-action=del]', function (el, e) {
	let product = el.closest('[data-product]');
	if (product) {
		removeClass(product, 'in-cart');
		cart.remove(product);
	}
}, true);
listener('click', '[data-product] [data-qty=trash]', function (el, e) {
	let product = el.closest('[data-product]');
	if (product) {
		removeClass(product, 'in-cart');
		cart.remove(product);
	}
}, true);

// удаляем со списка товаров
listener('click', '[data-product-item] [data-qty=trash]', function (el, e) {
	let product = el.closest('[data-product-item]');
	if (product) {
		removeClass(product, 'in-cart');
		cart.remove(product);
	}
}, true);

// удаляем товар на странице "Корзина"
listener('click', '[data-product-cart-item] [data-cart][data-action="del"]', function (el, e) {
	let product = el.closest('[data-product-cart-item]');
	if (product) {
		removeElement(product);

		cart.remove(product, {}, function (data) {
			if (!data.products_count) {
				location.reload();
			} else {
				cart.update({
					get_delivery_prices: true,
				})
			}
		});
	}
}, true);
